module.exports = __webpack_public_path__ + "img/faq-bkg.png";